export function getWhitelistLoading(state) {
    return state.WhitelistReducer.isLoading;
}

export function getWhitelists(state) {
    return state.WhitelistReducer.whitelists;
}